// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "spa-assets/js/stores/universal-preapplication-consumer-upac-store-es5") return "spa-assets/js/stores/universal-preapplication-consumer-upac-store-es5-359f3bfdc313ed01ed97.js";
	if (chunkId === "spa-assets/js/vendors/vue-router") return "spa-assets/js/vendors/vue-router-f6eb4160a2421ff7eb79.js";
	// return url for filenames based on template
	return undefined;
};